// 跑批监测类型枚举
export let batchBusiness = [
  {
    label: '用户',
    value: 'user'
  },
  {
    label: '合同',
    value: 'contract'
  },
  {
    label: '订单',
    value: 'order'
  },
  {
    label: '基本报告',
    value: 'basic_report'
  },
  {
    label: '年监报告',
    value: 'year_report'
  }
]
